<template>
  <simulador-card
    :title="$t('tools.expensesTitle')"
    :info="$t('tools.expensesInfo')"
  >
    <div class="expenses-container">
      <simulador-field
        id="despesa-energia"
        :label="$t('tools.energia')"
        type="number"
        :value="energia"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateEnergia"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-internet"
        :label="$t('tools.internet')"
        type="number"
        :value="internet"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateInternet"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-contador"
        :label="$t('tools.contador')"
        type="number"
        :value="contador"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateContador"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-sistema-onii"
        :label="$t('tools.sistemaOnii')"
        type="number"
        :value="sistemaOnii"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateSistemaOnii"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-conexao-maquininha"
        :label="$t('tools.conexaoMaquininha')"
        type="number"
        :value="conexaoMaquininha"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateConexaoMaquininha"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-aluguel"
        :label="$t('tools.aluguel')"
        type="number"
        :value="aluguel"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateAluguel"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-logistica"
        :label="$t('tools.logistica')"
        type="number"
        :value="logistica"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateLogistica"
        @change="calcularTotalDespesasFixas"
      />

      <simulador-field
        id="despesa-outros"
        :label="$t('tools.outros')"
        type="number"
        :value="outros"
        :step="0.01"
        unit="R$"
        unit-position="left"
        @input="updateOutros"
        @change="calcularTotalDespesasFixas"
      />
    </div>

    <simulador-field
      id="total-despesas-fixas"
      :label="$t('tools.totalDespesasFixas')"
      :value="totalDespesasFixas"
      unit="R$"
      unit-position="left"
      :is-result="true"
    />

    <simulador-field
      id="percentual-despesas"
      :label="$t('tools.percentualDespesas')"
      :value="percentualDespesas"
      unit="%"
      :formula="$t('tools.percentualDespesasFormula')"
      :is-result="true"
    />
  </simulador-card>
</template>

<script>
import SimuladorCard from "./SimuladorCard.vue";
import SimuladorField from "./SimuladorField.vue";

export default {
  name: "Despesas",
  components: {
    SimuladorCard,
    SimuladorField
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        energia: 800.0,
        internet: 100.0,
        contador: 250.0,
        sistemaOnii: 250.0,
        conexaoMaquininha: 99.0,
        aluguel: 500.0,
        logistica: 100.0,
        outros: 0.0,
        totalDespesasFixas: "2.099,00",
        percentualDespesas: "12,49%"
      })
    },
    faturamentoConservador: {
      type: [Number, String],
      default: 208064.0
    }
  },
  computed: {
    energia: {
      get() {
        return this.value.energia;
      },
      set(val) {
        this.$emit("input", { ...this.value, energia: val });
      }
    },
    internet: {
      get() {
        return this.value.internet;
      },
      set(val) {
        this.$emit("input", { ...this.value, internet: val });
      }
    },
    contador: {
      get() {
        return this.value.contador;
      },
      set(val) {
        this.$emit("input", { ...this.value, contador: val });
      }
    },
    sistemaOnii: {
      get() {
        return this.value.sistemaOnii;
      },
      set(val) {
        this.$emit("input", { ...this.value, sistemaOnii: val });
      }
    },
    conexaoMaquininha: {
      get() {
        return this.value.conexaoMaquininha;
      },
      set(val) {
        this.$emit("input", { ...this.value, conexaoMaquininha: val });
      }
    },
    aluguel: {
      get() {
        return this.value.aluguel;
      },
      set(val) {
        this.$emit("input", { ...this.value, aluguel: val });
      }
    },
    logistica: {
      get() {
        return this.value.logistica;
      },
      set(val) {
        this.$emit("input", { ...this.value, logistica: val });
      }
    },
    outros: {
      get() {
        return this.value.outros;
      },
      set(val) {
        this.$emit("input", { ...this.value, outros: val });
      }
    },
    totalDespesasFixas: {
      get() {
        return this.value.totalDespesasFixas;
      },
      set(val) {
        this.$emit("input", { ...this.value, totalDespesasFixas: val });
      }
    },
    percentualDespesas: {
      get() {
        return this.value.percentualDespesas;
      },
      set(val) {
        this.$emit("input", { ...this.value, percentualDespesas: val });
      }
    }
  },
  methods: {
    updateEnergia(val) {
      this.energia = val;
    },
    updateInternet(val) {
      this.internet = val;
    },
    updateContador(val) {
      this.contador = val;
    },
    updateSistemaOnii(val) {
      this.sistemaOnii = val;
    },
    updateConexaoMaquininha(val) {
      this.conexaoMaquininha = val;
    },
    updateAluguel(val) {
      this.aluguel = val;
    },
    updateLogistica(val) {
      this.logistica = val;
    },
    updateOutros(val) {
      this.outros = val;
    },
    formatarMoeda(valor) {
      return valor.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formatarPercentual(valor) {
      return (
        valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + "%"
      );
    },
    calcularTotalDespesasFixas() {
      // Converter todos os campos para números para evitar concatenação de strings
      const energia = parseFloat(this.energia) || 0;
      const internet = parseFloat(this.internet) || 0;
      const contador = parseFloat(this.contador) || 0;
      const sistemaOnii = parseFloat(this.sistemaOnii) || 0;
      const conexaoMaquininha = parseFloat(this.conexaoMaquininha) || 0;
      const aluguel = parseFloat(this.aluguel) || 0;
      const logistica = parseFloat(this.logistica) || 0;
      const outros = parseFloat(this.outros) || 0;

      // Somar todas as despesas
      const total =
        energia +
        internet +
        contador +
        sistemaOnii +
        conexaoMaquininha +
        aluguel +
        logistica +
        outros;

      // Formatar o resultado
      this.totalDespesasFixas = this.formatarMoeda(total);

      // Calcular o percentual em relação ao faturamento conservador
      this.calcularPercentualDespesas(total);

      // Emitir evento para o componente pai com o valor numérico (não formatado)
      this.$emit("despesas-fixas-atualizado", total);

      return total;
    },
    calcularPercentualDespesas(totalDespesas) {
      // Extrair o valor numérico do faturamento conservador
      let valorFaturamento = 0;

      if (typeof this.faturamentoConservador === "number") {
        valorFaturamento = this.faturamentoConservador;
      } else if (typeof this.faturamentoConservador === "string") {
        // Remover caracteres não numéricos, exceto vírgula e ponto
        const limpo = this.faturamentoConservador.replace(/[^\d,.]/g, "");
        // Substituir vírgula por ponto (padrão JS)
        const formatado = limpo.replace(/\./g, "").replace(",", ".");
        valorFaturamento = parseFloat(formatado) || 16800; // Usar valor padrão apenas se não conseguir extrair
      }

      // Se o valor for zero ou negativo, usar um valor padrão para evitar divisão por zero
      if (valorFaturamento <= 0) {
        valorFaturamento = 16800; // Valor padrão como fallback
      }

      // Calcular o percentual de despesas em relação ao faturamento
      const percentual = (totalDespesas / valorFaturamento) * 100;

      // Formatar como percentual
      this.percentualDespesas = this.formatarPercentual(percentual);

      // Emitir evento para o componente pai
      this.$emit("percentual-despesas-atualizado", percentual);

      return percentual;
    }
  },
  watch: {
    faturamentoConservador() {
      // Recalcular o percentual de despesas quando o faturamento conservador mudar
      this.calcularTotalDespesasFixas();
    }
  },
  mounted() {
    this.calcularTotalDespesasFixas();
  }
};
</script>

<style scoped>
.expenses-container {
  clear: both;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.expenses-container :deep(.field-group) {
  width: 50%;
  padding-right: 15px;
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .expenses-container :deep(.field-group) {
    width: 100%;
    padding-right: 0;
  }
}
</style>
